import { render, staticRenderFns } from "./PanelBase.vue?vue&type=template&id=65468b58"
import script from "./PanelBase.vue?vue&type=script&lang=js"
export * from "./PanelBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports